import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { Trans } from 'react-i18next';
import { PRZELEWY24_TERMS_LINK } from '@repo/shared/constants';

import { ClickableTypography } from '@/components/dashboard/components/loan-action-card/loan-action-card-builder/clickable-typography';

export function LoanTerms() {
  return (
    <Stack gap="10px">
      <Typography fontWeight="medium">
        <Trans components={[]} i18nKey="loanFormPage.agreements.form.fields.loanTerms.title" />
      </Typography>
      <Trans
        components={[
          <ClickableTypography
            key="link"
            perform={() => window.open(PRZELEWY24_TERMS_LINK, '_blank')}
            sx={{
              display: 'contents',
              width: 'auto',
            }}
          />,
        ]}
        i18nKey="loanFormPage.agreements.form.fields.loanTerms.content"
      />
    </Stack>
  );
}
